import React from "react";
import { Switch, Route } from "react-router-dom";
// new containers
import Conclusion from "../components/containers/Conclusion";
import Contact from "../components/containers/Contact";
import Payments from "../components/containers/Payments";
import Photo from "../components/containers/Photo";
import Rooms from "../components/containers/Rooms";
import Residents from "../components/containers/Residents";
import Profile from "../components/containers/Profile";
import Interval from "../components/containers/Interval";
import Diet from "../components/containers/Diet";
import GuestPackages from "../components/containers/GuestPackages";
import GuestPreferences from "../components/containers/GuestPreferences";
import GuestInteractionLevel from "../components/containers/GuestInteractionLevel";
import Pets from "../components/containers/Pets";
import CulturalBackground from "../components/containers/CulturalBackground";
import HealthAndMedical from "../components/containers/HealthAndMedical";
import Smoking from "../components/containers/Smoking";
import House from "../components/containers/House";
import HouseContinued from "../components/containers/HouseContinued";
import References from "../components/containers/References";
import FamilyInterests from "../components/containers/FamilyInterests";
import Holding from "../components/containers/Holding";
import Register from "../components/containers/Register";
import Info from "../components/containers/Info";
import Withdraw from "../components/containers/Withdraw";
import Referral from "../components/containers/Referral";
import PhoneVerification from "../components/containers/PhoneVerification";
import Address from "../components/Address";
import RegisteredRoute from "../../../shared/components/RegisteredRoute";
import AddressedRoute from "../../../shared/components/AddressedRoute";
import FirebaseAccountDetails from "../components/containers/FirebaseAccountDetails";
import FirebaseRegister from "../components/containers/FirebaseRegister";
import P from "../paths";

export default (
  <Switch>
    <RegisteredRoute path={P.CONCLUSION_PATH} component={Conclusion} />
    <RegisteredRoute path={P.CONTACT_PATH} component={Contact} />
    <RegisteredRoute path={P.PAYMENTS_PATH} component={Payments} />
    <RegisteredRoute path={P.PHOTO_PATH} component={Photo} />
    <RegisteredRoute path={P.ROOMS_PATH} component={Rooms} />
    <RegisteredRoute path={P.RESIDENTS_PATH} component={Residents} />
    <RegisteredRoute path={P.PROFILE_PATH} component={Profile} />
    <RegisteredRoute path={P.INTERVAL_PATH} component={Interval} />
    <RegisteredRoute path={P.DIET_PATH} component={Diet} />
    <RegisteredRoute path={P.GUEST_PACKAGES_PATH} component={GuestPackages} />
    <RegisteredRoute path={P.GUEST_PREFERENCES_PATH} component={GuestPreferences} />
    <RegisteredRoute path={P.GUEST_INTERACTION_LEVEL_PATH} component={GuestInteractionLevel} />
    <RegisteredRoute path={P.PETS_PATH} component={Pets} />
    <RegisteredRoute path={P.HEALTH_AND_MEDICAL_PATH} component={HealthAndMedical} />
    <RegisteredRoute path={P.CULTURAL_BACKGROUND_PATH} component={CulturalBackground} />
    <RegisteredRoute path={P.SMOKING_PATH} component={Smoking} />
    <RegisteredRoute path={P.HOUSE_PATH} component={House} />
    <RegisteredRoute path={P.HOUSE_CONTINUED_PATH} component={HouseContinued} />
    <RegisteredRoute path={P.REFERENCES_PATH} component={References} />
    <RegisteredRoute path={P.FAMILY_INTERESTS_PATH} component={FamilyInterests} />
    <RegisteredRoute path={P.HOLDING_PATH} component={Holding} />
    <RegisteredRoute path={P.INFO_PATH} component={Info} />
    <RegisteredRoute path={P.WITHDRAW_PATH} component={Withdraw} />
    <RegisteredRoute path={P.REFERRAL_PATH} component={Referral} />
    <RegisteredRoute path={P.PHONE_VERIFICATION_PATH} component={PhoneVerification} />
    <AddressedRoute path={P.REGISTER_PATH} component={Register} />
    <AddressedRoute path={P.FIREBASE_REGISTER_PATH} component={FirebaseRegister} />
    <AddressedRoute path={P.FIREBASE_DETAILS_PATH} component={FirebaseAccountDetails} />
    <Route exact path={P.ADDRESS_PATH} component={Address} />
  </Switch>
);
